import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher
const accessToken = localStorage.getItem('accessToken')
export const echo = new Echo({
    broadcaster: 'pusher',
    key: '5f7c63e635316d73f3f6',
    cluster: 'eu',
    forceTLS: true,
    authEndpoint: '/api/broadcasting/auth',
    auth: {
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
    },
})
